import style from './about.module.css';

export default function About() {
  return (
    <div className={style.about} id="about">
      <div>
        <h2>About Me</h2>
        <p>
          I'm a software engineer with experience in HTML emails and
          implementing and maintaining production level software for a
          construction company. I enjoy solving problems and brushing up on new
          technologies. Currently I am looking for a position as a Email
          Developer. My hope is to create value in a supportive work
          environment, both independently and collaboratively. I enjoy taking
          design mockups and turning them into highly functional HTML email
          documents. I'm always striving to be better than what I was yesterday
          by improving my skills and knowledge to get the best results. I pay
          attention to details and can work within tight deadlines.
        </p>
      </div>
    </div>
  );
}
